import { PageLayout } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";

import { UsersListPageContent } from "../organisms/UsersListPageContent";

export function UsersListPage() {
  const { t } = useTranslation();

  return (
    <PageLayout title={t("app.page.users.heading")}>
      <UsersListPageContent />
    </PageLayout>
  );
}
